<template>
  <div id="applications-filters">
    <v-card-title>
      <v-select
        :items="$store.state.moduleUser.permittedJobs"
        label="Métier (tous)"
        item-text="job_full_value"
        item-value="job_short_value"
        v-model="jobFilter"
        clearable
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        :items="$store.state.moduleApplications.available_status"
        label="Statut (tous)"
        item-text="status_value"
        item-value="status_value"
        v-model="statusFilter"
        clearable
        v-if="$store.getters['moduleUser/userIsResponsible']"
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Rechercher"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
  </div>
</template>

<script>
export default {
  name: 'applications-filters',
  data() {
    return {
      jobFilter: null,
      statusFilter: null,
      search: ''
    }
  },
  watch: {
    jobFilter() {
      this.$store.commit('moduleApplications/setFilterJob', this.jobFilter)
    },
    statusFilter() {
      this.$store.commit('moduleApplications/setFilterStatus', this.statusFilter)
    },
    search() {
      this.$store.commit('moduleApplications/setFilterSearch', this.search)
    }
  },
}
</script>